// Lucide icon: circle-alert (https://lucide.dev/icons/circle-alert)
import { CircleAlert } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconAttention = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <CircleAlert />
    </IconComponentStyled>
  )
}
